// extracted by mini-css-extract-plugin
export default {"elementsButtonContainer":"StripePaymentForm_elementsButtonContainer__isKuo","saveButton":"StripePaymentForm_saveButton__0IGzu","saveText":"StripePaymentForm_saveText__FDqM1"};